import { cfetch } from '@confluence/network';
import { fg } from '@confluence/feature-gating';

import { isNewUserQuery } from './isNewUser.ts';

/**
 * Stores origin attributes into onboarding state for new users
 * @param attributes origin attributes
 */
export const storeOrigin = (attributes: any) => {
	const URI = fg('cc-agg-migration-use-agg-endpoint')
		? '/gateway/api/graphql/slow'
		: window['GLOBAL_APOLLO_CLIENT_URI'] || '/cgraphql';
	const regionHint = fg('cc-agg-migration-use-agg-endpoint')
		? window['GLOBAL_AGG_REGION_STEERING_HINT']
		: undefined;

	void cfetch(`${URI}?q=isNewUserQuery`, {
		method: 'POST',
		credentials: 'include',
		headers: {
			'X-APOLLO-OPERATION-NAME': 'isNewUserQuery',
			'Content-Type': 'application/json',
			...(fg('cc-agg-migration-use-agg-endpoint')
				? {
						'atl-attribution': JSON.stringify({
							product: 'Confluence Cloud',
							service: 'confluence-frontend',
						}),
					}
				: {}),
			...(regionHint ? { 'Atl-Edge-Region-Hint': regionHint } : {}),
		},
		body: JSON.stringify({
			operationName: 'isNewUserQuery',
			query: isNewUserQuery,
		}),
	}).then(async (res: any) => {
		if (res.ok) {
			const data = await res.json();
			const isNewUser = data?.data?.isNewUser || false;
			if (!!isNewUser) {
				void cfetch('/wiki/rest/onboarding/1/store', {
					method: 'PUT',
					body: JSON.stringify({
						key: 'onboarding-origin-state:attributes',
						value: JSON.stringify(attributes),
					}),
					headers: {
						'Content-Type': 'application/json',
					},
				});

				window.dispatchEvent(new Event('onboardingAttributesUpdated'));
			}
		}
	});
};
